import React from 'react';
import {
    BooleanInput,
    CheckboxGroupInput,
    Create, NumberInput,
    ReferenceArrayInput,
    SelectInput,
    SimpleForm,
    TextInput
} from 'react-admin';
import resource from "../../config/resource";
import Upload from "../../components/inputs/Upload";

const RecipeCatsCreate = (props) => {
    return (
        <Create {...props}>
            <SimpleForm
                redirect="show"
            >
                <TextInput source="name" />
                <Upload segment={"recipeCategory"} type={"image"} source={"selectImage"}/>
                <Upload segment={"recipeCategory"} type={"image"} source={"deselectImage"}/>
                <SelectInput source={"ratio"} choices={[{id:'1:1',name:'1:1'},{id:"16:9",name:"16:9"}]}/>
                <SelectInput source={"type"} choices={ [{id:'recent',name:'recent'}, {id:'popular',name:'Popular'}, {id:'fast',name:'fast'}, {id:'all',name:'All'}, {id:'kitchen',name:'Kitchen'}]}/>
                <NumberInput source={"horizontalOrder"}/>
                <NumberInput source={"verticalOrder"}/>
                <ReferenceArrayInput
                    source="tags"
                    reference={resource.foodTag}
                    label="Tags"
                >
                    <CheckboxGroupInput source="name" />
                </ReferenceArrayInput>
                <BooleanInput source="deleted" />
            </SimpleForm>
        </Create>
    );
};

export default RecipeCatsCreate;